import styles from "./index.module.scss";
import dynamic from "next/dynamic";


const ReactBingmaps = dynamic(
  () => import("react-bingmaps").then(mod => mod.ReactBingmaps),
  { ssr: false }
);

const SideBySideContentSevenOneFour = ({
  kecContentData
}) => {
  globalThis?.navigator?.geolocation?.getCurrentPosition(position => {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;
  })
  return (
    <div className="w-full max-w-screen-lg mx-auto flex flex-col gap-6 font-[HelveticaRoman,Helvetica,sans-serif] max-[979px]:px-8">

      {/* --- Top Row --- */}
      <div className="flex flex-wrap w-full">

        {/* LEFT COLUMN */}
        <div className="w-full lg:w-7/12 flex flex-col gap-2">
          {kecContentData?.header && (
            <h2 className="text-[32px] m-0 mb-[0.5em] font-[HelveticaRoman,Helvetica,sans-serif] p-0 leading-[1.1em] font-[400] box-border text-[#232323]">
              {kecContentData.header}
            </h2>
          )}

          {kecContentData?.description && (
            <p className="text-[16px] text-[#232323] leading-normal whitespace-pre-line">
              {kecContentData.description}
            </p>
          )}
        </div>

        {/* SPACER */}
        <div className="hidden lg:block lg:w-1/12"></div>

        {/* RIGHT COLUMN */}
        <div className="w-full lg:w-4/12 flex flex-col gap-2">
          {(kecContentData?.phoneLabel || kecContentData?.phoneNumber) && (
            <p className="text-[16px] text-[#232323] leading-normal">
              {kecContentData?.phoneLabel && (
                <strong className="font-[HelveticaBold,Helvetica,sans-serif] font-[500] leading-[22.85px]">
                  {kecContentData.phoneLabel}:&nbsp;
                </strong>
              )}
              {kecContentData?.phoneNumber}
            </p>
          )}

          {kecContentData?.businessLabel && (
            <p className="text-[16px] text-[#232323] leading-normal">
              <strong className="font-[HelveticaBold,Helvetica,sans-serif] font-[500] leading-[22.85px]">
                {kecContentData.businessLabel}:
              </strong>
            </p>
          )}

          {Array.isArray(kecContentData?.businessHours) && kecContentData.businessHours.map((item, index) => (
            <p key={index} className="text-[16px] text-[#232323] leading-normal whitespace-pre-line">
              {item?.fields?.text}
            </p>
          ))}
        </div>
      </div>

      {/* Hidden Inputs */}
      <input type="hidden" className="koh-latitude" data-latitude={kecContentData?.latitude} />
      <input type="hidden" className="koh-longitude" data-longitude={kecContentData?.longitude} />

      {/* MAP container */}
      <div className={styles.mapWrapper}>
        <ReactBingmaps
          className={styles["react-bingmaps"]}
          bingmapKey={process.env.NEXT_PUBLIC_MAP_KEY}
          center={[28.6139, 77.209]} // Delhi
          zoom={15}
          key={"klafs-map"}
          disableStreetside={true}
          navigationBarMode={"square"}
          mapOptions={{
            showMapTypeSelector: false,
            NavigationBarMode: "square",
          }}
          disableScrollWheelZoom={true}
          mapHandlers={[
            {
              addHandler: "viewchangeend",
            },
          ]}
        />
      </div>

    </div>
  )
}

export default SideBySideContentSevenOneFour